var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TelephonyRedirectShell',{attrs:{"loading":_vm.loading,"not-found-context":_vm.notFoundContext,"error-message":_vm.errorMessage}})
}
var staticRenderFns = []

export { render, staticRenderFns }